import React from "react";
import PropTypes from "prop-types";
import { TablePagination, makeStyles } from "@material-ui/core";

const useStylesLocal = makeStyles(() => ({
  paginationText: {
    color: "var(--color-text-secondary) !important",
  },
}));

const TablePaginationFooter = ({
  count,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  onChangePage,
  onChangeRowsPerPage,
}) => {
  const classes = useStylesLocal();
  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      classes={{
        caption: classes.paginationText,
        toolbar: classes.paginationText,
        selectIcon: classes.paginationText,
        select: classes.paginationText,
        actions: classes.paginationText,
      }}
      backIconButtonProps={{
        style: { color: "var(--color-text-secondary)" },
      }}
      nextIconButtonProps={{
        style: { color: "var(--color-text-secondary)" },
      }}
    />
  );
};

TablePaginationFooter.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
};

TablePaginationFooter.defaultProps = {
  rowsPerPageOptions: [5, 10, 25],
};

export default TablePaginationFooter;
